import { P as d, A as b, b as n, n as a, t as m } from "./element-CV9utnHJ.js";
import { P as h } from "./pkt-slot-controller-D7CrjM52.js";
import { e as f, n as k } from "./ref-Dma3n3i8.js";
import { e as _ } from "./class-map-3ADKve8g.js";
import { r as v } from "./state-l4hGZdFJ.js";
import "./icon-D0IQAVwS.js";
import { u as g } from "./classutils-RQs1k6D9.js";
const C = { skin: { default: "beige" }, compact: { default: !1 }, closable: { default: !1 } }, u = {
  props: C
};
var x = Object.defineProperty, y = Object.getOwnPropertyDescriptor, o = (t, l, p, i) => {
  for (var s = i > 1 ? void 0 : i ? y(l, p) : l, r = t.length - 1, c; r >= 0; r--)
    (c = t[r]) && (s = (i ? c(l, p, s) : c(s)) || s);
  return i && s && x(l, p, s), s;
};
let e = class extends d {
  constructor() {
    super(), this.defaultSlot = f(), this.closable = u.props.closable.default, this.compact = u.props.compact.default, this.title = "", this.skin = u.props.skin.default, this._isClosed = !1, this.close = (t) => {
      this._isClosed = !0, this.dispatchEvent(new CustomEvent("close", { detail: { origin: t }, bubbles: !0 })), this.dispatchEvent(new CustomEvent("on-close", { detail: { origin: t }, bubbles: !0 }));
    }, this.slotController = new h(this, this.defaultSlot), this._isClosed = !1;
  }
  // Lifecycle
  updated(t) {
    super.updated(t), t.has("_isClosed") && g(this, "pkt-hide", this._isClosed);
  }
  // Render
  render() {
    const t = {
      "pkt-messagebox": !0,
      "pkt-messagebox--compact": this.compact,
      [`pkt-messagebox--${this.skin}`]: this.skin,
      "pkt-messagebox--closable": this.closable,
      "pkt-hide": this._isClosed
    };
    return n`<div class=${_(t)}>
      ${this.closable ? n`<div class="pkt-messagebox__close">
            <button
              @click=${this.close}
              class="pkt-btn pkt-btn--tertiary pkt-btn--small pkt-btn--icon-only"
              aria-label="Lukk"
            >
              <pkt-icon name="close" class="pkt-link__icon"></pkt-icon>
            </button>
          </div>` : b}
      ${this.title ? n`<div class="pkt-messagebox__title">${this.title}</div>` : b}
      <div class="pkt-messagebox__text" ${k(this.defaultSlot)}></div>
    </div>`;
  }
};
o([
  a({ type: Boolean, reflect: !0 })
], e.prototype, "closable", 2);
o([
  a({ type: Boolean, reflect: !0 })
], e.prototype, "compact", 2);
o([
  a({ type: String, reflect: !0 })
], e.prototype, "title", 2);
o([
  a({ type: String, reflect: !0 })
], e.prototype, "skin", 2);
o([
  v()
], e.prototype, "_isClosed", 2);
e = o([
  m("pkt-messagebox")
], e);
export {
  e as P
};
